import { render } from "./DefaultLayout.vue?vue&type=template&id=7a7d3cc3"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lykaon/gitlykaon/people-measurement-system.webapp-prestaging/cloud/pms_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__